document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.logo-nav-contain');

  if (!header) return;

  var lastScrollTop = 0;
  var ticking = false;

  function handleScroll() {
    var currentScroll =
      window.pageYOffset || document.documentElement.scrollTop;

    /* Always show the header at the very top */
    if (currentScroll <= 10) {
      header.classList.remove('scroll-header-hidden');
      lastScrollTop = currentScroll;
      ticking = false;
      return;
    }

    /* Scrolling down */
    if (currentScroll > lastScrollTop) {
      header.classList.add('scroll-header-hidden');
    }

    /* Scrolling up */
    else if (currentScroll < lastScrollTop) {
      header.classList.remove('scroll-header-hidden');
    }

    lastScrollTop = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(handleScroll);
      ticking = true;
    }
  });
});